
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire7898"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire7898"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $8l2wg = parcelRequire("8l2wg");

var $g65ub = parcelRequire("g65ub");

var $a8V6k = parcelRequire("a8V6k");
(0, $a8V6k.onReset)(()=>{
    const picker = document.getElementById("calendar-picker");
    picker.value = "";
});
const $8fdf4956d34de0a9$var$onPickerValueChange = (picker)=>{
    const value = picker.value;
    const date = new Date(value);
    (0, $8l2wg.triggerDateChange)(picker, date);
};
function $8fdf4956d34de0a9$var$observeValue(element) {
    let elementPrototype = Object.getPrototypeOf(element);
    let descriptor = Object.getOwnPropertyDescriptor(elementPrototype, "value");
    const { get: get, set: set } = descriptor;
    if (!get || !set) throw new Error("Cannot listen to value change; no getter or setter on value descriptor");
    Object.defineProperty(element, "value", {
        get: function() {
            return get.call(this);
        },
        set: function(val) {
            set.call(this, val);
            setTimeout(()=>{
                $8fdf4956d34de0a9$var$onPickerValueChange(element);
            }, 0);
        }
    });
}
(0, $g65ub.onInit)(()=>{
    const picker = document.getElementById("calendar-picker");
    $8fdf4956d34de0a9$var$observeValue(picker);
    picker.addEventListener("change", ()=>{
        $8fdf4956d34de0a9$var$onPickerValueChange(picker);
    });
});


//# sourceMappingURL=index.55efd2b7.js.map
